import React,{useState} from "react";
import "./App";

export default function Temprature(props) {
  let [unit, setUnit] = useState("celcius");

  function changetoFarenheit(event) {
    event.preventDefault();
    setUnit("farenheit");
  }

  function changetoCelcius(event) {
    event.preventDefault();

    setUnit("celcius");
  }

  function farenheite() {
    let farenheit = Math.round(((props.temprature * 9)/5) + 32);
    return farenheit;
  }

  if (unit == "celcius") {
    return (
      <div>
        <div className="left-part">
          <img id="current-temp-icon" src={props.url} />
          <h2 id="temprature">{props.temprature}</h2>
          <span className="span-tag-celc active">℃</span>
          <span className="line"> |</span>
          <span className="span-tag-far">
            <a href="/" onClick={changetoFarenheit}>
              °F
            </a>
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="left-part">
          <img id="current-temp-icon" src={props.url} />
          <h2 id="temprature">{farenheite()}</h2>
          <span className="span-tag-celc ">
            <a href="/" onClick={changetoCelcius}>
              °c
            </a>
          </span>
          <span className="line"> |</span>
          <span className="span-tag-far active">°F</span>
        </div>
      </div>
    );
  }
}
